import React from 'react'
import './previewFooter.css'
import personeLogoWhite from '../../images/persone-logo-white.png'
import personeLogoBlack from '../../images/persone-logo-black.png'
export const PreviewFooter = (props) => {
  return (
        <footer className={`footer-preview ${props?.theme}`}>
        <div className="footer-content">
            <div className='footerimg'>
                <div className="copyright">
                    { props?.theme === 'dark' ?
                        <img
                            src={personeLogoWhite}
                            className="persone-logo"
                            alt="Persone"
                            width={20}
                            height={20}
                            quality={100}
                            priority
                        />
                        :
                        <img
                            src={personeLogoBlack}
                            className="persone-logo"
                            alt="Persone"
                            width={20}
                            height={20}
                            quality={100}
                            priority
                        />
                    }
                    <p>© {new Date().getFullYear() - 1}-{new Date().getFullYear()} Persone. All rights reserved | Terms & Privacy</p>
                </div>
            </div>
        </div>
    </footer>
  )
}

